import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CountryTable } from './CountryTable';
import { StateTable } from './StateTable';
import { CityTable } from './CityTable';
import { getCities, getCountries, getStates } from '../../../../redux/actions/SocietyController/CtrlLocationAction/CtrlLocationAction';
import { usePageRefreshKey } from '../../../../context/PageRefreshContext';

const TABS = [
    { id: 0, label: 'Countries', icon: 'mdi:earth' },
    { id: 1, label: 'States', icon: 'mdi:flag-variant' },
    { id: 2, label: 'Cities', icon: 'mdi:city-variant-outline' },
];

const ADD_LABEL = { 0: 'Add Country', 1: 'Add State', 2: 'Add City' };

const LocationListLayer = () => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(0);
    const [addCountryModalOpen, setAddCountryModalOpen] = useState(false);
    const [addStateModalOpen, setAddStateModalOpen] = useState(false);
    const [addCityModalOpen, setAddCityModalOpen] = useState(false);

    const [searchQueryCountry, setSearchQueryCountry] = useState({ page: 1, limit: 10, search: '', status: null });
    const [searchQueryState, setSearchQueryState] = useState({ page: 1, limit: 10, search: '', status: null });
    const [searchQueryCity, setSearchQueryCity] = useState({ page: 1, limit: 10, search: '', status: null });

    // Header Refresh re-runs the active tab's fetch below.
    const refreshKey = usePageRefreshKey();

    const handleAddClick = () => {
        if (activeTab === 0) setAddCountryModalOpen(true);
        else if (activeTab === 1) setAddStateModalOpen(true);
        else setAddCityModalOpen(true);
    };

    useEffect(() => {
        if (activeTab === 0) {
            dispatch(getCountries({
                page: searchQueryCountry.page || 1,
                limit: searchQueryCountry.limit || 10,
                search: searchQueryCountry.search || '',
                status: searchQueryCountry.status || null,
            }));
        } else if (activeTab === 1) {
            dispatch(getStates({
                page: searchQueryState.page || 1,
                limit: searchQueryState.limit || 10,
                search: searchQueryState.search || '',
                status: searchQueryState.status || null,
            }));
        } else {
            dispatch(getCities({
                page: searchQueryCity.page || 1,
                limit: searchQueryCity.limit || 10,
                search: searchQueryCity.search || '',
                status: searchQueryCity.status || null,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQueryCountry, searchQueryState, searchQueryCity, activeTab, refreshKey]);

    return (
        <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden">
            {/* Header: tabs + add button */}
            <div className="tw-p-3 tw-border-b tw-border-gray-100 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-bg-gray-100 tw-rounded-lg tw-p-1">
                    {TABS.map((tab) => {
                        const active = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`tw-h-7 tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-transition-all ${
                                    active
                                        ? 'tw-bg-white tw-text-rose-600 tw-shadow-sm'
                                        : 'tw-bg-transparent tw-text-gray-500 hover:tw-text-gray-700'
                                }`}
                            >
                                <Icon icon={tab.icon} className={`tw-text-sm ${active ? 'tw-text-rose-500' : 'tw-text-gray-400'}`} />
                                {tab.label}
                            </button>
                        );
                    })}
                </div>
                <button
                    onClick={handleAddClick}
                    className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-rose-600 hover:tw-bg-rose-700 tw-transition-colors"
                >
                    <Icon icon="mdi:plus" className="tw-text-sm" />
                    {ADD_LABEL[activeTab]}
                </button>
            </div>

            {/* Body */}
            <div>
                {activeTab === 0 && (
                    <CountryTable
                        addCountryModalOpen={addCountryModalOpen}
                        setAddCountryModalOpen={setAddCountryModalOpen}
                        searchQuery={searchQueryCountry}
                        setSearchQuery={setSearchQueryCountry}
                    />
                )}
                {activeTab === 1 && (
                    <StateTable
                        addStateModalOpen={addStateModalOpen}
                        setAddStateModalOpen={setAddStateModalOpen}
                        searchQuery={searchQueryState}
                        setSearchQuery={setSearchQueryState}
                    />
                )}
                {activeTab === 2 && (
                    <CityTable
                        addCityModalOpen={addCityModalOpen}
                        setAddCityModalOpen={setAddCityModalOpen}
                        searchQuery={searchQueryCity}
                        setSearchQuery={setSearchQueryCity}
                    />
                )}
            </div>
        </div>
    );
};

export default LocationListLayer;
